import React, { useEffect, useState, useCallback, useMemo } from 'react';

// DEPENDENCIES
import isEmpty from 'lodash/isEmpty';
import lowerCase from 'lodash/lowerCase';
import { useFormikContext } from 'formik';

// GLOBAL FUNCTIONS
import { formatDate } from 'functions.js';

// HELPERS
import useRecordView from 'helpers/getRecordView';

// GLOBAL COMPONENTS
import Card from 'parts/card/Card';

// LOCAL COMPONENTS
import StatusItem from './parts/StatusItem';
import EstimatedDeliveryDate from './parts/EstimatedDeliveryDate';
import RebillStatusLog from './parts/RebillStatusLog';

// MAIN COMPONENT
const StatusForm = () => {
  const { values } = useFormikContext() || {};

  const {
    sale_status_log, //
    sales_status_name,
    estimated_delivery_date,
    rebill_status_log,
    sales_time
  } = values || {};

  const { isSales } = useRecordView();

  const currentStatus = useMemo(() => {
    return lowerCase(sales_status_name).replace(/\s/g, '');
  }, [sales_status_name]);

  const date = formatDate(new Date());
  const [backoutDate, setBackoutDate] = useState(date);
  const [dateEntered, setDateEntered] = useState({});

  const handleBackoutDateChange = useCallback(({ value }) => {
    const date = value ? formatDate(value) : '';
    setBackoutDate(date);
  }, []);

  useEffect(() => {
    if (sale_status_log) {
      const sold = sale_status_log.find(status => status.status_name === 'Sold');
      if (sold) {
        setDateEntered(sold);
      }
    }
  }, [sale_status_log]);

  return (
    <>
      {!isEmpty(dateEntered) ? <StatusItem {...dateEntered} statusName="Date Entered" /> : null}
      {sale_status_log?.length
        ? sale_status_log.map((s, i) => {
            return (
              <StatusItem
                {...s}
                key={s.status_log_id}
                // Don't show created by if first status is sold
                created_by={!isSales ? i !== 0 && s.status_name !== 'Sold' && s.created_by : s.created_by}
                logId={s.status_log_id}
                index={i}
                backoutDate={backoutDate}
                backoutMinDate={sales_time}
                onBackoutDateChange={handleBackoutDateChange}
              />
            );
          })
        : null}
      {currentStatus === 'order' && estimated_delivery_date ? (
        <EstimatedDeliveryDate date={estimated_delivery_date} />
      ) : null}
      {rebill_status_log?.length ? <RebillStatusLog /> : null}
    </>
  );
};

export default function StatusInfo(props) {
  return <Card title="Status" body={<StatusForm {...props} />} />;
}
